function separatePhoneNumberFromExtension(phone) {
  return {
    phone_number: phone.phone_number.substring(0, 10),
    extension: phone.phone_number.substring(10) + (phone.extension ?? ''),
  };
}

export default separatePhoneNumberFromExtension;
